import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { Button } from "reactstrap";
import { PaymentInputsWrapper, usePaymentInputs } from "react-payment-inputs";
import base_url from "../../api/bootapi";
import axios from "axios";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import images from "react-payment-inputs/images";
import "./PaymentModal.css";
import cancel from "../../assets/close.png";

const NoteModal = ({
note
}) => {
  const customStylesone = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      border: "none",
      padding: "28px 36px"
    },
    overlay: {
      zIndex: 9,
      backdropFilter: "blur(4px)",
      backgroundColor: 'rgba(0, 0, 0, 0.1)'
    }
    };
    
    const [isOpen, setIsOpen] = useState(false);

    const onRequestClose = () => {
     setIsOpen(false)
 }






    return (
      <>
      
     <Button color="primary" onClick={()=>setIsOpen(true)} style={{width:"fit-content",fontSize:"13px",padding:"4px 10px"}}>See Note</Button>
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStylesone}
      contentLabel="Payment Modal"
    >
    <div className="payment_modal">
      <p className="card_head">Note</p>

              <p style={{padding:"8px",whiteSpace:"pre-line",background:"#f4f4f4",minHeight:'inherit'}}>
                  {note}
     </p>
                </div>
                
                <div style={{display:"flex",justifyContent:"flex-end"}}>
                     <Button
                                   color="primary"
                                   onClick={onRequestClose}
                                //    style={{ width: "200px" }}
                                 >
                                   Close
                                 </Button>
                </div>
            </Modal>
            
             </>
  );
};

export default NoteModal;
